/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListObjectivesQueryResponse, ListObjectivesPathParams, ListObjectivesQueryParams, ListObjectives400, ListObjectives401, ListObjectives403, ListObjectives404, ListObjectives409, ListObjectives500 } from "../../types/planningTasksController/ListObjectives.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listObjectives } from "../../client/planningTasksController/listObjectives.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listObjectivesQueryKey = (organizationId: ListObjectivesPathParams["organizationId"] | undefined, params?: ListObjectivesQueryParams) => [{ url: '/api/organizations/:organizationId/objectives', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListObjectivesQueryKey = ReturnType<typeof listObjectivesQueryKey>

export function listObjectivesQueryOptions(organizationId: ListObjectivesPathParams["organizationId"] | undefined, params?: ListObjectivesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listObjectivesQueryKey(organizationId, params)
        return queryOptions<ListObjectivesQueryResponse, ResponseErrorConfig<ListObjectives400 | ListObjectives401 | ListObjectives403 | ListObjectives404 | ListObjectives409 | ListObjectives500>, ListObjectivesQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listObjectives(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List objectives across the organization (optionally one farm via ?establishmentId)
 * {@link /api/organizations/:organizationId/objectives}
 */
export function useListObjectives<TData = ListObjectivesQueryResponse, TQueryData = ListObjectivesQueryResponse, TQueryKey extends QueryKey = ListObjectivesQueryKey>(organizationId: ListObjectivesPathParams["organizationId"] | undefined, params?: ListObjectivesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListObjectivesQueryResponse, ResponseErrorConfig<ListObjectives400 | ListObjectives401 | ListObjectives403 | ListObjectives404 | ListObjectives409 | ListObjectives500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listObjectivesQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listObjectivesQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListObjectives400 | ListObjectives401 | ListObjectives403 | ListObjectives404 | ListObjectives409 | ListObjectives500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}